import { Stepper } from "@shared/components/Stepper";
import NewListStepOne from "./NewListStepOne";
import NewListStepTwo from "./NewListStepTwo";
import NewListStepThree from "./NewListStepThree";

const NewListForm = () => {
  const steps = [
    {
      title: "List Details",
      description: "",
      slug: "basic-info",
      component: <NewListStepOne />,
    },
    {
      title: "Filters & Preview",
      description: "",
      slug: "location",
      component: <NewListStepTwo />,
    },
    {
      title: "Preview",
      description: "Confirm your details",
      slug: "preview",
      component: <NewListStepThree />,
    },
  ];

  return (
    <div className="px-4 m-auto">
      <Stepper
        steps={steps}
        storageKey="list-stepper"
        enableRouting={true}
        allowStepClick={false}
        onStepChange={() => {}}
        onStepSave={() => {}}
        saveOnStepChange={true}
        onValidation={() => {}}
        onComplete={() => {}}
      />
    </div>
  );
};

export default NewListForm;
